<template>
  <div>
    <Main
      ref="main"
      :loading="loading"
      :tableData="tableData"
      :disabled="disabled"
      @submitDel="del"
    >
      <div slot="header">
        <b-button
          class="mr-2"
          size="sm"
          :disabled="disabled"
          variant="outline-success"
          @click="() => (orderBatchDialogVisible = true)"
        >
          <i class="el-icon-plus" />{{ $l('INDEX.btn_add') || '新增' }}
        </b-button>
      </div>
    </Main>
    <ChooseOrderBatchDialog
      :title="'订单批次信息'"
      :visible.sync="orderBatchDialogVisible"
      :changeOrderCode="changeOrderCode"
      type="checkbox"
      @confirm="orderBatchConfirm"
    />
  </div>
</template>
<script>
import Main from './main'
import ChooseOrderBatchDialog from '../../../choose-order-batch/dialog.vue'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: { Main, ChooseOrderBatchDialog },
  props: {
    orderInspectionDocCode: { type: String, default: '' },
    changeOrderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    isExpand: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      orderBatchDialogVisible: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderInspectionDocCode) return
      this.loading = true
      this.$api
        .changeOrderInspectionDocBatchListApi({
          orderInspectionDocCode: this.orderInspectionDocCode,
          changeOrderCode: this.changeOrderCode,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
    },
    orderBatchConfirm(data) {
      if (this.isExpand) {
        this.addDBData(data)
        return
      }
      this.addTableData(data)
    },
    addTableData(data) {
      if (!data || !data.length) return
      const tableData = data
        .map((i) => {
          return {
            orderBatchCode: i.orderBatchCode,
            orderBatchNo: i.orderBatchNo,
            identifyNo: i.identifyNo,
            deliveryDate: i.deliveryDate,
            outBillType: i.outBillType,
            dispatchPort: i.dispatchPort,
            destinationPort: i.destinationPort,
          }
        })
        .filter(
          (i) =>
            this.tableData.findIndex((j) => j.orderBatchNo === i.orderBatchNo) <
            0
        )
      this.tableData.push(...tableData)
    },
    addDBData(data) {
      const listBatchCode = data
        .map((i) => i.orderBatchCode)
        .filter(
          (i) => this.tableData.findIndex((j) => j.orderBatchCode === i) < 0
        )

      if (listBatchCode.length !== data.length) {
        this.$message(
          this.$l('inspection_choose_goods_repeat_tips') ||
            '已为您过滤掉重复的产品信息！'
        )
      }

      if (!listBatchCode || !listBatchCode.length) return
      const params = {
        orderInspectionDocCode: this.orderInspectionDocCode,
        changeOrderCode:this.changeOrderCode,
        listBatchCode,
      }
      this.loadingOpen()
      this.$api
        .changeOrderInspectionDocBatchSaveApi(params)
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          this.getData()
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    del(changeOrderInspectionDoceBatchCode) {
      const delRow = this.tableData.filter(
        (i) => i.changeOrderInspectionDoceBatchCode === changeOrderInspectionDoceBatchCode
      )
      if (this.isExpand) {
        this.delDBData(delRow)
        return
      }
      this.delTableData(delRow)
    },
    delDBData(delRows) {
      const listDocCode = delRows.map((i) => i.changeOrderInspectionDoceBatchCode)
      const dataCount = this.tableData.length || 0

      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .changeOrderInspectionDocBatchDelApi({ listDocCode })
          .then((res) => {
            this.loadingClose()
            const { status } = res
            if (status !== 200) {
              this.$message.error(
                this.$l('INDEX.tips_delete_no') || '删除失败！'
              )
              return
            }
            this.$message({
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.getData()
            if (listDocCode.length >= dataCount) this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
            this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
          })
      })
    },
    delTableData(delRows) {
      const tableData = this.tableData.filter(
        (i) =>
          delRows.findIndex((j) => i.orderBatchCode == j.orderBatchCode) < 0
      )
      this.tableData = [...tableData]
    },
    getTableData() {
      return this.tableData
    },
  },
}
</script>
